export const mobileHorizontal = 'screen and (max-width: 812px) and (orientation: landscape)';
export const mobileVertical = 'screen and (max-width: 767px) and (orientation: portrait)';
export const mobile = `${mobileHorizontal}, ${mobileVertical}`;

export const tabletHorizontal = 'screen and (min-width: 813px) and (orientation: landscape)';
export const tabletVertical = 'screen and (min-width: 768px) and (orientation: portrait)';
export const tablet = `${tabletHorizontal}, ${tabletVertical}`;

export const desktop = 'screen and (min-width: 1025px)';
